import { Address } from '@/types/addresses'

export const NAME_ALIAS_SOURCE_FIELDS = [
  'Job (Property) Name',
  'Ship To Name',
  'Ship To Attn',
  'Bill To Name',
  'Bill To Attn',
]

export const ADDRESS_ALIAS_SOURCE_FIELDS = [
  'Job Location Address',
  'Ship To Address',
  'Bill To Address',
]

export function buildNameAliasValues(text: string): Record<string, string> {
  return { 'Property Name': text }
}

export function buildAddressAliasValues(
  text: string,
  jsonValue: Partial<Address> | null | undefined,
): Record<string, string> {
  const address = jsonValue?.address
  if (!address) return { Address: text }

  // The Entrata property match compares Street Address, City and State with the
  // document's parsed address, and the text must be exactly equal. So these
  // three are copied as they are.
  // street2 is split on spaces. The last word is the Secondary Number and the
  // word before it is the Secondary Designator. The Entrata data list sync
  // splits street2 the same way.
  const street2Parts = address.street2?.split(' ') || []

  return {
    Address: text,
    'Formatted Address': address.single_line || '',
    'Street Address': address.street1 || '',
    'Secondary Designator': street2Parts.at(-2) || '',
    'Secondary Number': street2Parts.at(-1) || '',
    City: address.city || '',
    State: address.administrative_area || '',
    Zipcode: address.postal_code || '',
  }
}
